export default __webpack_public_path__ + "static/media/10.d0c3c524.jpg";